import React from "react";
import styled from "styled-components";
import FilterTag from "../library/FilterTag";
import { useSearchFiltersContext } from "../library/SearchFilter";
import { FilterData } from "../CandidatesListPage";
import { mediaMaxWidth } from "../../theme/mediaQueriesTemplates";

const EngagementListSelectedFilters = (props: Props) => {
  const { filters } = props;

  const statusTags = filters.status.map((status) => ({
    label: status.replace("_", " "),
    value: status,
  }));

  return (
    <SelectedFiltersWrapper>
      <FilterTagGroup tags={statusTags} filter="status" />
    </SelectedFiltersWrapper>
  );
};

type Tag = {
  label: string;
  value: string | string[];
};

const FilterTagGroup = (props: { filter: string; tags: Tag[] }) => {
  const { tags, filter } = props;
  const { remove } = useSearchFiltersContext();

  if (tags.length === 0) {
    return null;
  }

  return (
    <>
      {tags.map(({ label, value }) => (
        <FilterTag
          key={`${label}-${JSON.stringify(value)}`}
          onClick={() => remove(filter, value)}
        >
          {label}
        </FilterTag>
      ))}
    </>
  );
};

const SelectedFiltersWrapper = styled.div`
  margin-bottom: 0.5rem;
  margin-left: -0.25rem;
  margin-right: -0.25rem;

  ${mediaMaxWidth.smallTablet} {
    display: none;
  }
`;

type Props = {
  filters: FilterData;
};

export default EngagementListSelectedFilters;
